<template>
  <div>

    <Loader v-if="loading" cover/>

    <div v-else class="vx-row">

      <!-- LEFT SIDE -->
      <div class="vx-col sm:w-full lg:w-3/4 w-full mb-base">
        <!-- INFO TOPIC CONTENT -->
        <vx-card v-if="infoTopic">
          <!-- COVER PHOTO -->
          <div slot="no-body" class="card-cover">
            <img :src="getCoverPhoto(infoTopic.picturePath)"
                 alt="content-img" class="responsive card-img-top">
          </div>

          <!-- TOPIC -->
          <h4 class="card-title mb-3">
            {{ infoTopic.topicLocal }}
          </h4>

          <!-- INFO GROUP -->
          <div class="flex justify-between flex-wrap center mb-3">
            <vs-chip :color="infoTopic.infoGroup.color" transparent>
              {{ infoTopic.infoGroup.nameLocal }}
            </vs-chip>
          </div>

          <!-- CONTENT -->
          <div class="ql-editor" v-html="infoTopic.descriptionLocal"></div>

          <vs-divider></vs-divider>

          <!-- ATTACHMENT FILE & TOPIC INFO DATE -->
          <div class="flex justify-between align-items-center">

            <div>
              <vx-tooltip :title="$t('info-topic.download-attachment-file')" class="float-left">
                <a v-if="infoTopic && infoTopic.attachFilePath"
                   class="font-weight-bold align-items-center" href="#"
                   @click="onDownloadClick">
                  <feather-icon icon="DownloadIcon" svgClasses="h-6 w-6 stroke-current">
                  </feather-icon>
                </a>
              </vx-tooltip>
            </div>

            <small class="text-grey pt-2"> {{infoTopicDate}} </small>
          </div>

        </vx-card>

        <!-- INFO TOPIC NOT FOUND -->
        <vx-card v-else class="text-center">
          <h5 class="font-weight-normal">{{ $t('info-topic.not-found') }}</h5>
        </vx-card>
      </div>

      <!-- RIGHT SIDE -->
      <div class="vx-col sm:w-full lg:w-1/4 w-full">

        <!-- BACK BUTTON -->
        <vs-button class="w-full mb-base"
                   color="success"
                   @click="handlerBackClick">
          <span>{{ $t('general.back') }}</span>
        </vs-button>


        <!-- RECENT NEWS -->
        <h5 class="text-grey mb-4">{{$t('info-topic.recent-news')}}</h5>

        <template v-if="recentInfoTopics && recentInfoTopics.length > 0">
          <div v-for="recentInfoTopic in recentInfoTopics"
               :key="recentInfoTopic.id"
               class="mb-3">
            <div class="flex justify-between">

              <div class="media-aside mr-2 align-self-start">
                <a class="cursor-pointer" target="_self"
                   @click="handlerRecentInfoTopicClick(recentInfoTopic)">
                  <img class="rounded" height="70" width="100"
                       :src="getCoverPhoto(recentInfoTopic.picturePath)">
                </a>
              </div>

              <div class="media-body">
                <h6 class="blog-recent-post-title mb-2">
                  <a class="text-dark hover:text-primary cursor-pointer" target="_self"
                     @click="handlerRecentInfoTopicClick(recentInfoTopic)"
                     v-line-clamp="2">
                    {{ recentInfoTopic.topicLocal }}
                  </a>
                </h6>
                <span class="align-text-bottom text-grey mb-0">
                  {{formatDate(recentInfoTopic.createdAt)}}
                </span>
              </div>
            </div>
          </div>
        </template>


        <div v-else class="text-center mt-base">
          <h5 class="font-weight-normal">{{ $t('info-topic.not-found') }}</h5>
        </div>
      </div>
    </div>

  </div>
</template>

<script>

import _store from '@/store';
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import InfoTopic from '@/store/modules/university-news/info-topic/index';
import {createNamespacedHelpers} from "vuex";
import {getPhotoUrl} from "@/utils/upload";
import moment from "moment";
import {dateTimeFormat} from "@/utils/format";
import {config} from "@/utils/upload";

if (!_store.state.InfoTopic) _store.registerModule(`InfoTopic`, InfoTopic);

const {
  mapActions: mapInfoTopicActions,
} = createNamespacedHelpers(`InfoTopic`);


export default {
  name: "InfoTopicContent",
  components: {
    Loader: () => import('@/components/common-ui/loader-block/index.vue'),
  },
  data() {
    return {
      loading: false,
      infoTopic: null,
      recentInfoTopics: [],
      e_code: !localStorage.getItem("rsc") ? null : JSON.parse(localStorage.getItem("rsc")).e_code,
      r_stage: !localStorage.getItem("rsc") ? null : JSON.parse(localStorage.getItem("rsc")).r_stage,
    }
  },
  watch:{
    async '$route.params' (val, oldVal){
      if(val && val !== oldVal){
        await this.loadData();
      }
    },
  },
  computed: {
    infoTopicDate(){
      if(this.infoTopic){
        return this.formatDate(this.infoTopic.createdAt);
      }
      return '-';
    }
  },
  methods: {
    ...mapInfoTopicActions({
      getInfoTopic: 'getInfoTopic',
      getRecentInfoTopicsForStudent: 'getRecentInfoTopicsForStudent',
    }),
    onDownloadClick() {
      const url = `${config.url.downloadFile}${this.e_code}/${this.r_stage}/${this.infoTopic.attachFilePath}`;
      window.open(url, '_blank');
    },
    handlerBackClick(){
      this.$router.push('/');
      // this.$router.go(-1);
    },
    handlerRecentInfoTopicClick(recentInfoTopic){
      this.$router.push(`/info-topic-content/${recentInfoTopic.id}`);
    },
    getCoverPhoto(path) {
      if (path) {
        return getPhotoUrl(path);
      }
      return `static/images/classroom-placeholder.jpeg`
    },
    formatDate(date){
      return moment(date).format(dateTimeFormat.momentYYYYMMDD)
    },
    async loadData() {
      this.loading = true;
      if (this.$route.params.id) {
        const payload = {
          id: this.$route.params.id
        }
        this.infoTopic = await this.getInfoTopic(payload);
      }

      const recentPayload = {
        currentInfoTopic: this.$route.params.id
      }
      this.recentInfoTopics = await this.getRecentInfoTopicsForStudent(recentPayload);

      this.loading = false;
    }
  },
  async beforeMount() {
    await this.loadData();
  }
}
</script>

<style scoped>
.blog-recent-post-title{
  line-height: 23px;
  letter-spacing: 0;
}
</style>
